import React from 'react'

export const ProgressBar = () => {
    return (
        <div className="loading">
            <div className="loading__bar w-full relative h-[5px] bg-purple-200 overflow-hidden "></div>
        </div>
    )
};
